<template>
    <div id="app">
        <div class="vistDetailsAll">
<!--            <div class="vistDetail">-->
<!--                <div class="vistLi" v-if="res.acceptReturnFlagDesc">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>是否接受回访:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="borders floats">-->
<!--                            <img src="./img/yes.png" alt="">-->
<!--                        </div>-->
<!--                        <div class="vistCont floats">{{res.acceptReturnFlagDesc}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi"  v-if="res.name">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>姓名:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.name}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.sexDesc">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>性别:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.sexDesc}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.birthDay">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>出生日期:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.birthDay}}</div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="vistLi" v-if="res.number">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>身份证号:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.number}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.timeOfOperation">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>手术时间:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.timeOfOperation}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.dischargeTime">-->
<!--                    <p class="visitLiTitle" >-->
<!--                        <span>*</span>出院时间:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.dischargeTime}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.lastTestDischargeDiagnosis">-->
<!--                    <p class="visitLiTitle" >-->
<!--                        <span>*</span>出院诊断:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.lastTestDischargeDiagnosis}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.animalHeat">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>体温:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.animalHeat}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.bloodPressureS">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>血压:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">-->
<!--                            <span v-if="res.bloodPressureS">{{res.bloodPressureS}}</span>-->
<!--                            <span v-if="res.bloodPressureE">-</span>-->
<!--                            <span v-if="res.bloodPressureE">{{res.bloodPressureE}}</span>-->
<!--                            </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.height">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>身高:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.height}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi"  v-if="res.weight">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>体重:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats">{{res.weight}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.relationshipWithPatient">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>与患者关系:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="vistCont floats"> {{res.relationshipWithPatient}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="vistLi" v-if="res.relationshipWithPatient">-->
<!--                    <p class="visitLiTitle">-->
<!--                        <span>*</span>资料来源:</p>-->
<!--                    <div class="visitLiBorder">-->
<!--                        <div class="borders floats">-->
<!--                            <img src="./img/yes.png" alt="">-->
<!--                        </div>-->
<!--                        <div class="vistCont floats">{{res.relationshipWithPatient}}</div>-->
<!--                    </div>-->
<!--                    <div class="visitLiBorder margins" v-if="res.dataSource==3">-->
<!--                        <div class="vistCont floats">{{res.dataSourceDesc}}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <div v-for="(res,index) in ary" :key="index" class="vistDetailDomConter">
                <div class="titles" v-if="res.name=='Title'">
                    <p>{{res.props.value}}</p>
                </div>
                <p v-if="res.name=='HtmlText'" v-html="res.props.content" class="titlesce"></p>
                <div class="vistLi" v-if="(res.name=='Input'||res.name=='DateTimePicker'||res.name=='DatePicker')&&res.props.value">
                    <p class="visitLiTitle">
                        <span>*</span>{{res.props.title}}:</p>
                    <div class="visitLiBorder">
                        <div class="vistCont floats">{{res.props.value}} </div>
                        <div v-if="res.props.unit" class="vistContUnit">{{res.props.unit}}</div>
                    </div>
                </div>
                <div class="vistLi" v-if="res.name=='Radio'&&res.props.value">
                    <p class="visitLiTitle">
                        <span>*</span>{{res.props.title}}:</p>
                    <div class="visitLiBorder" v-if="res.props.value==item.val" v-for="(item,index) in res.props.options" :key="index">
                        <div class="borders floats">
                            <img src="./img/yes.png" alt="">
                        </div>
                        <div class="vistCont floats">{{item.desc}}</div>
                    </div>
                </div>
                <div class="vistLi" v-if="res.name=='MultiSelect'&& res.props.value.lenth>0">
                    <p class="visitLiTitle">
                        <span>*</span>{{res.props.title}}:</p>
                    <div class="visitLiBorder margins" v-if="res.props.value.indexOf(item.val)>=0" v-for="(item,index) in res.props.options" :key="index">
                        <div class="borders floats">
                            <img src="./img/yes.png" alt="">
                        </div>
                        <div class="vistCont floats">{{item.desc}}</div>
                    </div>
                </div>
                <div class="vistLi" v-if="res.name=='RadioAndInput'&&res.props.value">
                    <p class="visitLiTitle">
                        <span>*</span>{{res.props.title}}:</p>
                    <div class="visitLiBorder margins" v-if="res.props.value==item.val" v-for="(item,index) in res.props.options" :key="index">
                        <div class="borders floats">
                            <img src="./img/yes.png" alt="">
                        </div>
                        <div class="vistCont floats">{{item.desc}}</div>
                    </div>
                </div>
                <div class="vistLi" v-if="res.name=='RadioAndInput'&&res.children&&res.children.ishow==res.props.value">
                    <p class="visitLiTitle">
                        <span>*</span>{{res.children.props.leftText}}:</p>
                    <div class="visitLiBorder">
                        <div class="vistCont floats">{{res.children.value}} </div>
                        <div v-if="res.children.unit" class="vistContUnit">{{res.children.unit}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { getOrderSingleReturnInfo } from '@/api/visitDetails.js'
export default {
  name: 'app',
  data: function() {
    return {
      res: {},
      ary: []
    }
  },
  created() {
    Toast.loading({
      duration: 1000,
      mask: true,
      message: '加载中...'
    })
    this.init(PAGE_PARAMS.id)
  },
  methods: {
    init(id) {
      Toast.loading({
        duration: 400,
        mask: true,
        message: '加载中...'
      })
      getOrderSingleReturnInfo({ id:id}).then(res => {
        this.res = res
        this.ary = JSON.parse(res.templateJson)
        console.log(this.ary)
      })
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.vistDetailsAll {
  width: 100%;
  min-height: 100%;
  margin-bottom: 100px;
}
.vistDetail {
  width: 100%;
}
.vistDetailDomConter {
  //   .vistDetailDom {
  // padding-left: 17px;
  // padding-right: 16px;
  .titles {
    margin-top: 13px;
    padding-left: 17px;
    width: 100%;
    height: 79px;
    background: url('./img/back1.png') no-repeat;
    background-size: 100% 100%;
    p {
      padding-top: 29px;
      font-size: 17px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
    }
  }
  .titlesce {
    padding-left: 17px;
    padding-right: 16px;
    font-size: 15px;
    font-family: SourceHanSansCN-Normal;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
}
// }
.floats {
  float: left;
}
.vistLi {
  width: 100%;
  padding-left: 16px;
  padding-right: 17px;
  .visitLiTitle {
    width: 100%;
    height: 15px;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    span {
      margin-right: 4px;
      font-size: 15px;
      color: rgba(248, 64, 37, 1);
    }
  }
  .margins {
    margin-top: 13px;
  }
  .visitLiBorder {
    width: 100%;
    height: 45px;
    //   background: rgba(216, 228, 233, 1);
    border: 1px solid rgba(255, 163, 7, 1);
    .borders {
      width: 12px;
      height: 12px;
      // background: rgba(216, 228, 233, 1);
      border: 1px solid rgba(214, 211, 211, 1);
      border-radius: 1px 1px 1px 1px;
      margin: 17px 0 16px 15px;
      img {
        display: block;
        width: 8px;
        height: 8px;
        margin: 1px auto;
      }
    }
    .vistCont {
      margin-left: 15px;
      font-size: 15px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      line-height: 45px;
    }
    .vistContUnit {
      float: right;
      font-size: 15px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      margin-right: 15px;
      line-height: 45px;
    }
  }
}
</style>
